import { useEffect, useState } from "react";

import { isNotEmptyArray } from "@chef/utils/array";
import { useAppDispatch } from "@chef/state-management/hooks";
import { closeModal, openModal } from "@chef/state-management";

import { FloatingBar } from "./FloatingBar";
import { useSignupSession } from "../hooks/useSignupSession";

interface CheckoutBarProps {
  disabled: boolean;
  onBeforeGoToCheckout: () => Promise<void>;
}

export const CheckoutBar = ({
  onBeforeGoToCheckout,
  disabled,
}: CheckoutBarProps) => {
  const dispatch = useAppDispatch();
  const [errors, setErrors] = useState<string[]>([]);
  const { updateSignupSession } = useSignupSession();

  const handleGoToCheckout = async () => {
    await onBeforeGoToCheckout();

    const url = new URL("/api/signup/callback", window.location.origin);

    const { redirectUri, errors } = await updateSignupSession({
      payment: {
        redirectUri: url.toString(),
      },
      cancellationUrl: window.location.href,
    }).unwrap();

    if (isNotEmptyArray(errors)) {
      setErrors(errors);
      return;
    }

    if (redirectUri) {
      window.location.href = redirectUri;
    }
  };

  useEffect(() => {
    if (isNotEmptyArray(errors)) {
      dispatch(
        openModal({ id: "CHECKOUT_ERRORS", onClose: () => setErrors([]) }),
      );
    } else {
      dispatch(closeModal());
    }
  }, [errors, dispatch]);

  return (
    <FloatingBar
      id="go-to-checkout-button"
      disabled={disabled}
      onContinue={handleGoToCheckout}
    />
  );
};
